import { PrerequisiteRuleTypes, type ExtensionConfig } from '@goto/shell-common'
import { getOOSArtifactUrl } from '../helpers/experience-helpers'
import { getFeatureFlag } from '../helpers/shell-helpers'
import { UnleashFlags } from '../models/feature-flag.models'
import { createMsTeamsIntegrationConfigIfFlagEnabled } from '../helpers/ms-teams-integration-helpers'

const integrationFlagSuffix = 'oos-webinar'

const extensionConfig: ExtensionConfig = {
  id: '@goto/oos-webinar-app',
  get url() {
    const version = getFeatureFlag(UnleashFlags.OOS_WEBINAR_VERSION, 'release')
    return new URL(getOOSArtifactUrl('webinar-extension', version))
  },
  prerequisites: {
    [PrerequisiteRuleTypes.ENTITLEMENTS]: 'g2w',
    [PrerequisiteRuleTypes.ACCOUNT_SETTINGS]: 'webinar.isWebinarGoToAppEnabled',
  },
  integrations: {
    get msTeams() {
      return createMsTeamsIntegrationConfigIfFlagEnabled(integrationFlagSuffix)
    },
  },
}

export default extensionConfig
